const initState = {
  fetchSignature: {
    success: null,
    error: null,
    code: null,
    message: null,
  },
  validateSignature: {
    success: null,
    error: null,
    code: null,
    message: null,
    accountNumber: null,
    accountCreationDate: null,
  },
};

export default initState;
